import { IToolSearchResult } from 'types/quoteEditor.types';
import { filterPillsIncludingKeys } from 'utils/pillsFormat';
import { IpillsByReference } from 'types/orders';
import { resolveSpecLabel } from '../DeviceDescription';
import DescriptionItem, { ISpec } from '../DescriptionItem/DescriptionItem';

interface IDeviceDescriptionFromCatalog {
  tool: IToolSearchResult;
}

/**
 * Renderiza un grid de especificaciones del producto del catálogo seleccionado.
 * Muestra categoría, marca y las specs dinámicas disponibles en las pills del producto.
 */
const DeviceDescriptionFromCatalog = ({ tool }: IDeviceDescriptionFromCatalog) => {
  const pillSpecs: ISpec[] = Object.entries(filterPillsIncludingKeys(tool.pills as IpillsByReference)).map(
    ([key, value]) => ({ label: resolveSpecLabel(key), value })
  );

  const specs: ISpec[] = [
    ...(tool.category ? [{ label: 'Categoría', value: tool.category }] : []),
    ...(tool.brand ? [{ label: 'Marca', value: tool.brand }] : []),
    ...pillSpecs
  ];

  if (specs.length === 0) return null;

  return (
    <div className="deviceDescription deviceDescriptionFromCatalog">
      {specs.map(spec => (
        <DescriptionItem key={spec.label} spec={spec} />
      ))}
    </div>
  );
};

export default DeviceDescriptionFromCatalog;
